var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgO(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0069 1.97732C22.6806 0.675132 20.5335 0.675132 19.2072 1.9719L15.5983 5.5068C14.7666 5.30062 13.8989 5.17854 13.0009 5.17854C11.097 5.17854 9.3119 5.68042 7.76724 6.54584L5.75006 4.6034L1 9.31841L3.25483 11.4887C2.70494 12.7475 2.39545 14.1311 2.39545 15.5879C2.39545 21.3284 7.15379 26 13.0009 26C18.8479 26 23.6063 21.3284 23.6063 15.5879C23.6063 13.2006 22.7745 11.0031 21.3929 9.24516L24.0097 6.68148C25.3306 5.38472 25.3306 3.2768 24.0069 1.97732ZM12.9981 22.4868C9.124 22.4868 5.97388 19.3914 5.97388 15.5906C5.97388 15.0833 6.03467 14.5923 6.13967 14.1148C7.4467 14.85 9.14058 14.671 10.2431 13.5777C11.4645 12.365 11.5308 10.466 10.4559 9.1692C11.2462 8.86536 12.1028 8.69445 13.0009 8.69445C16.875 8.69445 20.0251 11.7899 20.0251 15.5906C20.0251 19.3914 16.8722 22.4868 12.9981 22.4868Z",
    fill: "#E94E24",
    stroke: "#E94E24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/o.9a173823e8e92318c473bfb4b2072aec.svg";
export { ForwardRef as ReactComponent };